import React, { FC } from 'react'
import KycPopupComponent from './components/kyc/KycPopupComponent'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <KycPopupComponent />
    </QueryClientProvider>
  )
}

export default App
